import { Inject, Injectable, Injector } from '@angular/core';

import { Utilities_FlowService } from './Utilities.flow.index';

import { IntraOne_generate_data_1310_by_shipping_container_idService } from './IntraOne.flow.index';
import { IntraOne_generate_data_1380_by_shipping_container_idService } from './IntraOne.flow.index';
import { IntraOne_generate_data_1380_by_task_idService } from './IntraOne.flow.index';
import { IntraOne_pallet_activation_flowService } from './IntraOne.flow.index';
import { IntraOne_receive_data_0550Service } from './IntraOne.flow.index';
import { IntraOne_receive_data_4011Service } from './IntraOne.flow.index';
import { IntraOne_receive_data_flowService } from './IntraOne.flow.index';
import { IntraOne_send_data_1310_by_shipping_container_IdService } from './IntraOne.flow.index';
import { IntraOne_send_data_1380_by_expected_shipping_container_idService } from './IntraOne.flow.index';
import { IntraOne_send_data_1380_by_task_idService } from './IntraOne.flow.index';

import { $frontendTypes } from './IntraOne.frontend.types'

@Injectable({ providedIn: 'root' })
export class IntraOne_FlowService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_FlowService);
  }

    public Utilities: Utilities_FlowService;
  public IntraOne: IntraOne_FlowService = this;

  // injecting lazily in order to avoid circular dependencies
 
  private _generate_data_1310_by_shipping_container_id: IntraOne_generate_data_1310_by_shipping_container_idService;
  public async generate_data_1310_by_shipping_container_id($inParams: { shipping_container_id: number, is_hold?: boolean, mode: string }): Promise< { result?: any }> {
    if(!this._generate_data_1310_by_shipping_container_id) { 
      this._generate_data_1310_by_shipping_container_id = this.injector.get(IntraOne_generate_data_1310_by_shipping_container_idService);
    }
    return this._generate_data_1310_by_shipping_container_id.run($inParams);
  }
   
   

   
 
  private _generate_data_1380_by_shipping_container_id: IntraOne_generate_data_1380_by_shipping_container_idService;
  public async generate_data_1380_by_shipping_container_id($inParams: { expected_shipping_container_id: number }): Promise< { result?: any[] }> {
    if(!this._generate_data_1380_by_shipping_container_id) { 
      this._generate_data_1380_by_shipping_container_id = this.injector.get(IntraOne_generate_data_1380_by_shipping_container_idService);
    }
    return this._generate_data_1380_by_shipping_container_id.run($inParams);
  }
   
   

   
 
  private _generate_data_1380_by_task_id: IntraOne_generate_data_1380_by_task_idService;
  public async generate_data_1380_by_task_id($inParams: { task_id: number }): Promise< { result?: any }> {
    if(!this._generate_data_1380_by_task_id) { 
      this._generate_data_1380_by_task_id = this.injector.get(IntraOne_generate_data_1380_by_task_idService);
    }
    return this._generate_data_1380_by_task_id.run($inParams);
  }
   
   

   
 
  private _pallet_activation_flow: IntraOne_pallet_activation_flowService;
  public async pallet_activation_flow($inParams: { shipping_container_id: number }): Promise< { reason?: string[] }> {
    if(!this._pallet_activation_flow) { 
      this._pallet_activation_flow = this.injector.get(IntraOne_pallet_activation_flowService);
    }
    return this._pallet_activation_flow.run($inParams);
  }
   
   

   
 
  private _receive_data_0550: IntraOne_receive_data_0550Service;
  public async receive_data_0550($inParams: { target_warehouse_name: string, target_location_name: string }): Promise< { reason?: string[], log?: string[] }> {
    if(!this._receive_data_0550) { 
      this._receive_data_0550 = this.injector.get(IntraOne_receive_data_0550Service);
    }
    return this._receive_data_0550.run($inParams);
  }
   
   

   
 
  private _receive_data_4011: IntraOne_receive_data_4011Service;
  public async receive_data_4011($inParams: { field_to_update: string, warehouse_name: string }): Promise< { reason?: string[] }> {
    if(!this._receive_data_4011) { 
      this._receive_data_4011 = this.injector.get(IntraOne_receive_data_4011Service);
    }
    return this._receive_data_4011.run($inParams);
  }
   
   

   
 
  private _receive_data_flow: IntraOne_receive_data_flowService;
  public async receive_data_flow($inParams: { inputs_0550: { target_warehouse_name: string, target_location_name: string }, inputs_4011: { licensplate_field_to_update: string, warehouse_name: string } }): Promise< { reason?: string[] }> {
    if(!this._receive_data_flow) { 
      this._receive_data_flow = this.injector.get(IntraOne_receive_data_flowService);
    }
    return this._receive_data_flow.run($inParams);
  }
   
   

   
 
  private _send_data_1310_by_shipping_container_Id: IntraOne_send_data_1310_by_shipping_container_IdService;
  public async send_data_1310_by_shipping_container_Id($inParams: { shipping_container_id: number, mode: string, is_hold?: boolean }): Promise< { reason?: string[] }> {
    if(!this._send_data_1310_by_shipping_container_Id) { 
      this._send_data_1310_by_shipping_container_Id = this.injector.get(IntraOne_send_data_1310_by_shipping_container_IdService);
    }
    return this._send_data_1310_by_shipping_container_Id.run($inParams);
  }
   
   

   
 
  private _send_data_1380_by_expected_shipping_container_id: IntraOne_send_data_1380_by_expected_shipping_container_idService;
  public async send_data_1380_by_expected_shipping_container_id($inParams: { expected_shipping_container_id: number }): Promise< { reason?: string[] }> {
    if(!this._send_data_1380_by_expected_shipping_container_id) { 
      this._send_data_1380_by_expected_shipping_container_id = this.injector.get(IntraOne_send_data_1380_by_expected_shipping_container_idService);
    }
    return this._send_data_1380_by_expected_shipping_container_id.run($inParams);
  }
   
   

   
 
  private _send_data_1380_by_task_id: IntraOne_send_data_1380_by_task_idService;
  public async send_data_1380_by_task_id($inParams: { task_id?: number }): Promise< { reason?: string[] }> {
    if(!this._send_data_1380_by_task_id) { 
      this._send_data_1380_by_task_id = this.injector.get(IntraOne_send_data_1380_by_task_idService);
    }
    return this._send_data_1380_by_task_id.run($inParams);
  }
   
   

   
}
